export class ClientSite {
    private static readonly siteNamePrefixRegex = new RegExp('^[A-Z]{3} - ');
    siteId: number;
    siteName: string;

    constructor(siteId: number, siteName: string) {
        this.siteId = siteId;
        this.siteName = ClientSite.GenerateDisplayName(siteName);
    }

    private static GenerateDisplayName(originalName: string): string {
        return originalName.replace(ClientSite.siteNamePrefixRegex, '');
    }
}
